// Plans are priced by auction sheets read and bid estimates made a month — the work (and AI
// cost) that scales with how hard a shop is buying; an estimate costs about nine sheets to run.
// Paperwork, cars and landed cost are unlimited on every plan.
export const PLANS = [
    {
        id: 'starter',
        name: 'Starter',
        k: '始',
        who: 'One buyer, a few cars at a time.',
        lines: [
            'Hunts for your own lot',
            'Email support'
        ]
    },
    {
        id: 'shop',
        name: 'Shop',
        k: '店',
        who: 'A shop buying every week, for stock and for customers.',
        lines: [
            'Customer hunts with match alerts and weekly digests',
            'Outbox: customer emails from your own mailbox',
            'Setup call'
        ],
        featured: true
    },
    {
        id: 'dealer',
        name: 'Dealer',
        k: '商',
        who: 'High volume across several buyers.',
        lines: [
            'Everything in Shop',
            'Hands-on setup of your agents, mailbox and current stock'
        ]
    }
];
export const EVERY_PLAN = [
    'Unlimited imported cars, documents and entry packets',
    'Landed cost and profit per car, from your real paperwork',
    'Auction search across JapanCarDirect, JDM Auc and Pacific Coast JDM',
    'As many hunts as you like',
    'Ninja auction-sheet lookups with your own Ninja login',
    'Sheet requests to your agent from your own mailbox'
];
